import * as React from "react";
import {
  TacticLoader,
  type TacticLoaderProps
} from "@cmp-src/loaders/TacticLoader/TacticLoader";

type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl";
type SpinnerVariant = "default" | "muted" | "white";

const sizeMap: Record<SpinnerSize, TacticLoaderProps["size"]> = {
  xs: "xxs",
  sm: "xs",
  md: "sm",
  lg: "sm",
  xl: "md"
};

const variantColorMap: Record<SpinnerVariant, string> = {
  default: "#49A8CE",
  muted: "#9CA3AF",
  white: "#FFFFFF"
};

export interface SpinnerProps {
  /** From "xs" (8px) to "xl" (48px); "md" (default) and "lg" are both 32px. */
  size?: SpinnerSize;
  /** "default" brand blue, "muted" grey or "white" for dark surfaces. */
  variant?: SpinnerVariant;
  className?: string;
}

/** The Tactic loader in named sizes and colours, announced as "Loading". */

const Spinner: React.FC<SpinnerProps> = ({
  size = "md",
  variant = "default",
  className
}) => {
  return (
    <TacticLoader
      size={sizeMap[size]}
      color={variantColorMap[variant]}
      className={className}
    />
  );
};
Spinner.displayName = "Spinner";

export { Spinner };
